/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CheckboxCheckedDesigner(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CheckboxCheckedDesigner',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 14 * scale,
      viewBox: '0 0 14 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"fill":"#008547","width":"14","height":"14","rx":"7"}),createElement('path', {"stroke":"#FFF","strokeWidth":"2.25","d":"m3 6.5 3 3 5-5"})))
}
